module.exports = __webpack_public_path__ + "img/img85.ff7083ea.png";